import { useState, useEffect } from "react";

const ColorSwatch = ({ colorName, colorHex, colorId, isSelected, onSelect }) => (
    <div
        className={`w-6 h-6 rounded-full cursor-pointer transition ease-in-out duration-150 border-2 ${isSelected
                ? "border-gray-500 ring-2 ring-offset-1 ring-gray-300"
                : "border-transparent"
            }`}
        style={{ backgroundColor: colorHex }}
        onClick={() => onSelect(colorId)}
        title={colorName}
    ></div>
);

const SizeButton = ({ sizeName, sizeId, isSelected, onSelect }) => (
    <button
        type="button"
        className={`px-3 py-1 text-xs font-medium rounded-md transition duration-150 ${isSelected
                ? "bg-gray-600 text-white shadow-md"
                : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-100"
            }`}
        onClick={() => onSelect(sizeId)}
    >
        {sizeName}
    </button>
);

export function ProductVariantSelector({
    variants,
    defaultColorId,
    defaultSizeId,
    onColorChange,
    onSizeChange,
}) {
    const [selectedColorId, setSelectedColorId] = useState(null);
    const [selectedSizeId, setSelectedSizeId] = useState(null);

    // Set default selections on mount
    useEffect(() => {
        if (defaultColorId) {
            setSelectedColorId(defaultColorId);
        } else {
            setSelectedColorId(variants?.[0]?.color_id);
        }
    }, [defaultColorId, variants]);

    // Set default size when color changes
    useEffect(() => {
        const colorObj = variants?.find((v) => v.color_id === selectedColorId);
        const firstSize = colorObj?.sizes?.[0];

        if (defaultSizeId && defaultColorId !== selectedColorId) {
            setSelectedSizeId(firstSize?.size_id);
        } else if (defaultSizeId) {
            setSelectedSizeId(defaultSizeId);
        } else if (firstSize) {
            setSelectedSizeId(firstSize?.size_id);
        }
    }, [selectedColorId, defaultSizeId, variants]);

    // Send selected color to parent
    useEffect(() => {
        if (onColorChange) onColorChange(selectedColorId);
    }, [selectedColorId]);

    // Send selected size to parent
    useEffect(() => {
        if (onSizeChange) onSizeChange(selectedSizeId);
    }, [selectedSizeId]);

    const selectedColor = variants?.find(
        (v) => v.color_id === selectedColorId
    );

    return (
        <div>
            {/* Color Section */}
            <div className="flex gap-1 mb-2">
                {variants?.map((color) => (
                    <ColorSwatch
                        key={color.color_id}
                        colorHex={color.color_hex}
                        colorId={color.color_id}
                        colorName={color.color}
                        isSelected={selectedColorId === color.color_id}
                        onSelect={setSelectedColorId}
                    />
                ))}
            </div>

            {/* Size Section */}
            <div className="flex gap-1">
                {selectedColor?.sizes?.map((size) => (
                   (size.size_code !=='FS' && size.size_code !=='N/A') && <SizeButton
                        key={size.size_id}
                        sizeName={size.size_code}
                        sizeId={size.size_id}
                        isSelected={selectedSizeId === size.size_id}
                        onSelect={setSelectedSizeId}
                    />
                ))}
            </div>
        </div>
    );
}
export default ProductVariantSelector;